import Vue from 'vue'
import App from './App'
import router from './router'
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({ el: '#app', router, render: h => h(App) })